/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2023 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

const defaultHeight = 200;

export interface layoutProps {
  columns: number;
  columnWidth: number;
  gutterWidth: number;
  gutterHeight: number;
}

export type Position = [number, number];

export default function doLayout(itemsHeight: number[], props: layoutProps) {
  const {
    columns, columnWidth, gutterWidth, gutterHeight
  } = props;
  const columnHeights = Array.from(new Float32Array(columns));
  const positions: Position[] = itemsHeight.map((itemHeight) => {
    const index = columnHeights.indexOf(Math.min.apply(null, columnHeights));
    const height = itemHeight || defaultHeight;
    const x = index * columnWidth + index * gutterWidth;
    const y = columnHeights[index];
    columnHeights[index] += Math.round(height) + gutterHeight;
    return [x, y];
  });
  const gridHeight: number = Math.max.apply(null, columnHeights) - gutterHeight;
  return { positions, gridHeight };
}

